import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadManagerComponent } from './upload-manager.component';
import { DropZoneModule } from '@motes-sdk/directives';
import { CountUpModule } from 'ngx-countup';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [UploadManagerComponent],
    imports: [
        CommonModule,
        DropZoneModule,
        CountUpModule,
        SvgIconModule,
    ],
    exports: [UploadManagerComponent]
})
export class UploadManagerModule { }
